// extracted by mini-css-extract-plugin
module.exports = {"swiper":"BannerSlider_swiper__342nx","slide":"BannerSlider_slide__1DYdt","slideMobile":"BannerSlider_slideMobile__2hESM"};